import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { Loader, ErrorMessage } from 'components';
import Dropdown from 'react-dropdown'

@inject(rootStore => ({
    paperworkEntryStore: rootStore.paperworkEntryStore,
    routerStore: rootStore.routerStore,
    paperworkEntryEditStore : rootStore.paperworkEntryEditStore
}))

@observer
class PaperworkEntryEdit extends React.Component {
    constructor(props) {
        super(props);

        this.onSubmit = this.onSubmit.bind(this);
        this.onFieldChange = this.onFieldChange.bind(this);
        this.onDropdownChange = this.onDropdownChange.bind(this);
        this.renderUpdateResultMessage = this.renderUpdateResultMessage.bind(this);    
        this.onChecboxChange = this.onChecboxChange.bind(this);    
        this.isFormValid = this.isFormValid.bind(this);    

        this.state = {
            form : {
                email: '',
                status : {
                    value: '',
                    description : ''
                },
                sendEmail : false
            }
        };
    }

    async componentDidMount() {
        const {  paperworkEntry } = this.props.paperworkEntryStore;
        this.onDropdownChange({ label : paperworkEntry.paperworkStatus.description, value : paperworkEntry.paperworkStatus.id});
    }

    async refreshData() {
        const { paperworkEntryStore, paperworkEntry } = this.props;
        await paperworkEntryStore.getPaperworkEntry(paperworkEntry.id);
        await paperworkEntryStore.getPaperworkEntryHistory(paperworkEntry.id)
    }

    async onSubmit(event) {
        event.preventDefault();

        if(this.isFormValid())
        {
            const { form } = this.state;
            const {  paperworkEntry } = this.props.paperworkEntryStore;
    
            var model = {
                paperworkEntryId : paperworkEntry.id, 
                paperworkStatusId : form.status.value,
                sendEmail : form.sendEmail,
                emailContent : form.email
            }
            await this.props.paperworkEntryStore.updatePaperworkEntryStatus(paperworkEntry.id, model);
            await this.refreshData();
        }
    }

    isFormValid() {
        const { paperworkEntryStore } = this.props;
        const {  paperworkEntry } = this.props.paperworkEntryStore;
        const { form } = this.state;

        if(paperworkEntry.paperworkStatus.id == form.status.value) {
            paperworkEntryStore.setError("Please change Paperwork status!");
            return false;
        }
        paperworkEntryStore.setError(null);
        return true;
    }

    onFieldChange(event) {
        const  form  = {...this.state.form};
        form[event.target.name] = event.target.value;
        this.setState({form});  
    }

    onDropdownChange(data) {
        const  form  = {...this.state.form};
        form.status.value = data.value;
        form.status.description = data.label;
        this.setState({form});
    }

    onChecboxChange(event) {
        const form  = {...this.state.form};
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        form.sendEmail = value;
        this.setState({ form });   
    }

    renderUpdateResultMessage() {
        const { error, successMessage } = this.props.paperworkEntryStore;
        if(error) {
           return <div className="alert alert-warning"><p>{error}</p></div>   
        }
        else if(successMessage) {
           return <div className="alert alert-success"><p>{successMessage} </p></div>         
        }
        return null;
    }

    render() {    
        const { loading, 
                paperworkEntry, 
                error, 
                paperworkStatusLookup 
            } = this.props.paperworkEntryStore;
      
        const { form } = this.state;
        
        if (loading) {
            return <Loader />
        }

        if (paperworkEntry) {
            return (
                <div>                 
                        <div className="box box--med box--white box__shadow--1">
                            <section>
                            <h4 className="type--small type--bold type--letterspace--wide type--uppercase spc--bottom--sml">Status Edit</h4>                  
                            <form className="form" onSubmit={this.onSubmit}>
                                <div className="spc--bottom--med">
                                    <label>Status</label>
                                    <Dropdown options={paperworkStatusLookup} 
                                            value={form.status.value} 
                                            onChange={this.onDropdownChange}  
                                            placeholder="Select an option" />
                                </div>
                                <div className="spc--bottom--med">
                                    <input id="sendEmailCheckbox" className="input--check" 
                                       type="checkbox" 
                                       checked={form.sendEmail || false} 
                                       onChange={this.onChecboxChange} />
                                         <label htmlFor="sendEmailCheckbox">Send Email</label>
                                </div>
                                                              
                               { form.sendEmail &&                
                                <div className="spc--bottom--med">
                                <label>Additional email content</label>
                                <input className="input input--text input--med"
                                    name = "email" 
                                    type="text" 
                                    value={form.email.value} 
                                    onChange={this.onFieldChange} />  
                                </div> 
                                }
                                    {this.renderUpdateResultMessage()}      
                                    <button type="submit" className="btn btn--primary btn--med">
                                        Submit
                                    </button>
                                    { loading && <span style={{ paddingLeft: 10 }} className="type--small spc--left--sm">Editing...</span> }
                            </form>
                        </section>
                       </div>
                </div>
            )
        }

        return <ErrorMessage message={error} />
    }
}

export { PaperworkEntryEdit }




// WEBPACK FOOTER //
// ./src/modules/paperwork-entry/components/PaperworkEntryEdit.js